import { Component, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import * as moment from 'moment';
import { CredentialService } from 'src/app/services/core/credential/credential.service';
import { FundingSourceService } from 'src/app/services/core/funding-source/funding-source.service';
import { StatisticsService } from 'src/app/services/core/statistics/statistics.service';
import { NUMBER_OF_RECORDS } from 'src/app/utils/common.utils';
import { exportToExcel } from 'src/app/utils/utils.common';
@UntilDestroy()

@Component({
  selector: 'app-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.css']
})
export class ReportComponent implements OnInit {
  selectedCompany:any = '';
  selectedFundingsource:any = '';
  entities:any = [];
  selectedStatus:any;
  search:any
  filteredUsersList:any = [];
  totalPages = 0;
  totalResults = 0;
  preFundingSource:any = {};
  currentPage: number = 1;
  kpiData:any;
  todayDate: any;
  dateRange:any = []
  fundingSourceList: any;
  preCompanies:any;
  allCompanies:any
  numberOfRecords = NUMBER_OF_RECORDS;
  setTab = 'company'
  source = 'original'
  paymentStatus: any = '';
  
  constructor(
    private statisticsService: StatisticsService,
    private credentialService:CredentialService,
    private fundingSource: FundingSourceService,
    
  ){}

  ngOnInit(){
    this.todayDate = [
          moment().startOf('day').toISOString(),
          moment().endOf('day').toISOString()
        ];
    this.getKpi()
    this.generateKpiData()
    this.getCompanies();
    this.getFundingSource();
  }

  changeState(tab:string){
    this.selectedCompany = '';
    this.selectedFundingsource = '';
    this.setTab = tab
    this.kpiData = [];
    this.getKpi();
  }

    changeSource(tab:string){
    this.selectedCompany = '';
    this.selectedFundingsource = '';
    this.source = tab
    if (tab === 'original') {
      this.paymentStatus = '';
    }
    this.kpiData = [];
    this.getKpi();
  }

  onPaymentFilterChange() {
    this.kpiData = [];
    this.getKpi();
  }


getKpi() {
  let queryParam:any = {
    time: [this.todayDate[0], this.todayDate[1]],
    type: this.setTab,
    source: this.source
  }

  if (this.selectedCompany) {
    queryParam.company = this.selectedCompany.id;
  }

  if (this.selectedFundingsource) {
    queryParam.fundingsource = this.selectedFundingsource.id;
  }

  if (this.source !== 'original' && this.paymentStatus) {
    queryParam.payment = this.paymentStatus;
  }



  this.statisticsService.get(queryParam)
    .pipe(untilDestroyed(this))
    .subscribe((result: any) => {
      if (result && result.length) {
        const [{ data, ...kpiData }] = result;
        this.kpiData = kpiData;
        this.entities = data.sort(
          (a: any, b: any) => (b.total || 0) - (a.total || 0)
        );
      }
    });
}


  filterBySelection() {
    this.getKpi();
  }
  
  generateKpiData() {
    const dateRange = {
      startDate: this.todayDate[0],
      endDate: this.todayDate[1]
    };
    this.statisticsService.multiSheet(this.kpiData, this.entities, dateRange, this.setTab, this.source)
  }

 

   getCompanies() {
    const queryparams = {
      limit: 9999,
      isActive:true
    }
    this.credentialService.getPicker(queryparams)
      .pipe(untilDestroyed(this)).subscribe((data: any) => {
        if (data && data.results ) {
          this.allCompanies = data.results;
        }
      })
  }
   getFundingSource() {
    const queryparams = {
      limit: 9999,
      isActive:true
    }
    this.fundingSource.getPicker(queryparams)
      .pipe(untilDestroyed(this)).subscribe((data: any) => {
        if (data && data.results) {
          this.fundingSourceList = data.results.sort((a: any, b: any) =>
              (a.title).toLowerCase().localeCompare((b.title).toLowerCase())
            );
        }
      })
  }

  onDateChange(event: any) {
    this.todayDate = [
      event[0].toISOString(),
      moment(event[1]).endOf("day").toISOString(),
    ];
    this.kpiData = null;
    this.entities = null;
    this.getKpi();
  }

}
